import { MessageCircleQuestion } from "lucide-react";

export function DailyQuestionPost({ q }) {
  return (
    <div className="rounded-3xl bg-gradient-to-br from-sky-50 via-white to-rose-50 border-2 border-sky-200 p-6 text-center space-y-2" data-testid="daily-question-post">
      <p className="text-[11px] font-extrabold uppercase tracking-[0.3em] text-sky-600 flex items-center justify-center gap-1.5"><MessageCircleQuestion className="w-3.5 h-3.5" /> Frage des Tages</p>
      <h3 className="font-display text-xl sm:text-2xl font-black text-slate-900 leading-snug" data-testid="daily-question-text">{q.q}</h3>
      <p className="text-xs text-slate-500">Antworte unten in den Kommentaren und sammle Punkte 💬</p>
    </div>
  );
}
